module.exports = __webpack_public_path__ + "static/media/amused.7978b15e.png";